import axios from 'axios';
import _this from '../main'
import store from '@/store';
import api from '@/libs/api';
import presetTime from './time'
import { clear } from 'idb-keyval'
import Cookies from "js-cookie";

let util = {};

util.title = function (title) {
  title = title || 'tutordata-server-analysis';
  window.document.title = title;
};
util.ajaxUrl = process.env.NODE_ENV === 'development' ? 'https://dev.tutordata.cn' : '/';     //dev


// util.ajaxUrl = 'https://dev.tutordata.cn';     //dev
// util.ajaxUrl = 'http://devi.tutordata.cn';     //dev
// util.ajaxUrl = 'http://uat.tutordata.cn';     //uat
// util.ajaxUrl = 'http://bii.wifiin.cn';     //Ali


util.ajax = axios.create({
  baseURL: util.ajaxUrl,
  timeout: 1800000
});

let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = (config) => {
  for (let p in pending) {
    if (!/dashboards/.test(_this.$route.name)) {
      // if (pending[p].u === config.url + '&' + config.method) {
      let eventAnalysis = /\/api\/events\/report\//.test(pending[p].u) && (pending[p].u === config.url + '&' + config.method); //事件分析
      let propertyAnalysis = /\/api\/user\/properties\/report\//.test(pending[p].u) && (pending[p].u === config.url + '&' + config.method); //属性分析
      let intervalAnalysis = /\/api\/interval\/report\//.test(pending[p].u) && (pending[p].u === config.url + '&' + config.method); //间隔分析
      let distributionAnalysis = /\/api\/distribution\/report\//.test(pending[p].u) && (pending[p].u === config.url + '&' + config.method); //分布分析
      let ltvAnalysis = /\/api\/ltv\/report\//.test(pending[p].u) && (pending[p].u === config.url + '&' + config.method); //ltv分析
      if (eventAnalysis || propertyAnalysis || intervalAnalysis || distributionAnalysis || ltvAnalysis) { //当当前请求在数组中存在时执行函数体,仅对report进行拦截
        pending[p].f(); //执行取消操作
        pending.splice(p, 1); //把这条记录从数组中移除
      }

    } else {
      //切换概览列表时，取消上一个概览的获取分析数据的请求
      if (/\/api\/events\/report\//.test(pending[p].u) && (/\/api\/dashboard\/items\//.test(config.url)) && (config.method === 'get')) {
        pending[p].f(); //执行取消操作
        pending.splice(p, 1); //把这条记录从数组中移除
      }
    }

  }
};

const dateUnit = {
  0: '日',
  1: '一',
  2: '二',
  3: '三',
  4: '四',
  5: '五',
  6: '六',
}

const requestList = []

//添加请求拦截器
util.ajax.interceptors.request.use(config => {
  if (config.headers.userId == undefined || config.headers.token == undefined) {
    _this.$router.push('/view/login')
  }


  let ary = [
    '^/api/user/behavior/paths/report',
    '^/api/retentions/report',
    '^/api/attribution/report',
    '^/api/ltv/report',
    '^/api/events/report',
  ]

  if (ary.some(item => RegExp(item).test(config.url))) {
    config.cancel = axios.CancelToken.source()
		if (!config.cancelToken) {
      config.cancelToken = config.cancel.token
    }
    let idx = requestList.findIndex(
      item => config.url === decodeURIComponent(escape(atob(item.url))),
    )
      console.log(idx, 'wwww', [...requestList])
    if (
			idx !== -1
		) {
      requestList[idx].cancel.cancel()
      requestList.splice(idx, 1)
		}
		config.idx =
			requestList.push({
        url: btoa(unescape(encodeURIComponent(config.url))),
        cancel: config.cancel
      }) - 1

  } else {
    removePending(config); //在一个ajax发送前执行一下取消操作
    if (typeof config.cancelToken === 'function') {
          pending.push({ u: config.url + '&' + config.method, f: config.cancelToken });
        } else {
          config.cancelToken = new cancelToken((c) => {
            // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
            pending.push({ u: config.url + '&' + config.method, f: c });
          });
        }
      }

  if (Object.prototype.toString.call(config.data) !== '[object FormData]') {  // FormData数据不能转成字符串，必须是对象
    config.data = encodeURIComponent(JSON.stringify(config.data));    //发送之前统一编码
  }
  store.commit('SET_REQUESTS', pending);
  return config;
}, error => {
  console.log(error, 'error')
  return Promise.reject(error);
});

//添加响应拦截器
util.ajax.interceptors.response.use(response => {
  if (typeof (response.config.idx) === 'number') {
    requestList.splice(response.config.idx, 1)
  }
  removePending(response.config);  // 在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
  if (response.data.status === -1001001) {
    _this.$Message.error('登录信息失效，请重新登录');
    _this.$store.commit('logout', _this);
    _this.$router.push('/view/login');

    _this.$store.commit("clearOpenedSubmenu");
    localStorage.clear()
    var cookies = Cookies.get();

    for (var cookieName in cookies) {
      Cookies.remove(cookieName);
    }
    clear()
  } else if (response.data.status === -1002001) {
    _this.$Message.warning('用户没有权限');
  } else if (response.data.status === -1004001) {
    _this.$Message.warning('密码错误');
  } else if (response.data.status === -1004002) {
    _this.$Message.warning('帐户未注册');
  } else if (response.data.status === -1003003) {
    _this.$Message.warning('帐户已注册');
  }
  // else if (response.data.status < 0) {
  //   _this.$Message.warning('返回值错误');
  // }
  return response;
}, error => {
  if (error.config) {
    if (typeof (error.config.idx) === 'number') {
      requestList.splice(error.config.idx, 1)
    }
  }
  else return Promise.reject(error);
});

util.inOf = function (arr, targetArr) {
  let res = true;
  arr.forEach(item => {
    if (targetArr.indexOf(item) < 0) {
      res = false;
    }
  });
  return res;
};

util.oneOf = function (ele, targetArr) {
  if (targetArr.indexOf(ele) >= 0) {
    return true;
  } else {
    return false;
  }
};

util.showThisRoute = function (itAccess, currentAccess) {
  if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
    return util.oneOf(currentAccess, itAccess);
  } else {
    return itAccess === currentAccess;
  }
};

util.getRouterObjByName = function (routers, name) {
  if (!name || !routers || !routers.length) {
    return null;
  }
  // debugger;
  let routerObj = null;
  for (let item of routers) {
    if (item.name === name) {
      return item;
    }
    routerObj = util.getRouterObjByName(item.children, name);
    if (routerObj) {
      return routerObj;
    }
  }
  return null;
};

util.handleTitle = function (vm, item) {
  if (typeof item.title === 'object') {
    return vm.$t(item.title.i18n);
  } else {
    return item.title;
  }
};

util.setCurrentPath = function (vm, name) {
  let currentPathArr = [];
  vm.$store.commit('setCurrentPath', currentPathArr);

  return currentPathArr;
};

util.openNewPage = function (vm, name, argu, query) {
  let pageOpenedList = vm.$store.state.app.pageOpenedList;
  let openedPageLen = pageOpenedList.length;
  let i = 0;
  let tagHasOpened = false;
  while (i < openedPageLen) {
    if (name === pageOpenedList[i].name) { // 页面已经打开
      vm.$store.commit('pageOpenedList', {
        index: i,
        argu: argu,
        query: query
      });
      tagHasOpened = true;
      break;
    }
    i++;
  }

  vm.$store.commit('setCurrentPageName', name);
};

util.toDefaultPage = function (routers, name, route, next) {
  let len = routers.length;
  let i = 0;
  let notHandle = true;
  while (i < len) {
    if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
      route.replace({
        name: routers[i].children[0].name
      });
      notHandle = false;
      next();
      break;
    }
    i++;
  }
  if (notHandle) {
    next();
  }
};

util.fullscreenEvent = function (vm) {
  vm.$store.commit('initCachepage');
};

//动态加载app路由
//菜单列表
util.setAppRouter = function (menulist, appRouter) {
  menulist.forEach(item => {
    if (item.children && item.children.length > 0) {
      if (item.name === 'channel') util.setChannelRouters(item.children, appRouter)
      else util.setAppRouter(item.children, appRouter);
    } else {
      if (item.name === 'Dashboard') {
        appRouter.children.push({
          path: `/view/dashboards/:projectId`,
          name: 'dashboards' + item.projectId,
          meta: {
            title: item.title,
            projectId: item.projectId
          },
          params: {
            projectId: item.projectId
          },
          component: () => import(`@\/views\/dashboards\/dashboards.vue`)
        })
      } else if (item.name === 'enterprise-overview') {
        util.setEnterpriseRouters(item.name, appRouter)
      } else if (item.name === 'enterprise-config') {
        util.setEnterpriseRouters(item.name, appRouter)
      } else {
        appRouter.children.push({
          path: `/view/${item.name}/:projectId`,
          name: item.name + item.projectId,
          meta: {
            title: item.title,
            projectId: item.projectId
          },
          params: {
            projectId: item.projectId
          },
          component: () => import(`@\/views\/${item.name}\/${item.name}.vue`)
        })
      }
    }
  })
};
util.setChannelRouters = (menuList, appRouter) => {
  menuList.forEach(item => {
    appRouter.children.push({
      path: `/view/${item.name}/:projectId`,
      name: item.name + item.projectId,
      meta: {
        title: item.title,
        projectId: item.projectId
      },
      params: {
        projectId: item.projectId
      },
      component: () => import(`@\/views\/channel\/${item.name}.vue`)
    })
  })
}
util.setEnterpriseRouters = (name, appRouter) => {
  appRouter.children.push({
    path: `/view/${name}`,
    name: name,
    component: () => import(`@\/views\/management\/${name}.vue`)
  })
}
//获取设置概览列表，添加到左侧菜单，并刷新路由
util.setDashboardsMenu = () => {
  return new Promise(resolve => {
    api.getDashboards(store.state.app.projectId)
      .then(res => {
        let menuList = store.state.app.menuList;
        let baseDashboard = {
          projectId: store.state.app.projectId,
          title: '我的数据概览'
        };
        let selfDashboards = res.data.fields.dashboards.filter(item => item.self === true);
        let sharedDashboards = res.data.fields.dashboards.filter(item => item.self === false);
        let selfMenuItems = selfDashboards.map(item => {
          return Object.assign({}, baseDashboard, {
            id: item.id,
            title: item.name,
            icon: 'dash-board',
            name: `dashboards_${item.name}`
          })
        });
        let sharedMenuItemChildren = sharedDashboards.map(item => {
          return Object.assign({}, baseDashboard, {
            id: item.id,
            title: item.name,
            icon: 'dash-board',
            name: `dashboards_${item.name}`,
            projectId: store.state.app.projectId
          })
        });
        let sharedMenuItem = Object.assign({}, baseDashboard, {
          title: '别人分享的概览',
          icon: 'dash-board',
          children: sharedMenuItemChildren
        });

        menuList.find(item => item.name === 'Dashboard').icon = 'dash-board';
        menuList.find(item => item.name === 'Dashboard').children = selfMenuItems;
        if (sharedMenuItemChildren.length) {
          menuList.find(item => item.name === 'Dashboard').children.push(sharedMenuItem);
        }
        store.commit('SET_MENU_LIST', menuList);
        store.commit('SET_DASH_LIST', res.data.fields.dashboards);
        resolve();
      })
  })
};
//下拉权限管理、左下角按钮
util.setOtherRouter = (otherlist, otherRouter) => {
  otherlist.forEach(item => {
    //admin用户管理,项目管理
    if (item.projectId === 0) {
      otherRouter.children.push({
        path: `/view/${item.name}`,
        name: item.name,
        meta: {
          title: item.title,
          projectId: item.projectId
        },
        component: () => import(`@\/views\/management\/${item.name}.vue`)
      })
      //普通管理员权限，右上角下拉菜单
    } else if (item.type === 'DropDown') {
      otherRouter.children.push({
        path: `/view/${item.name}/:projectId`,
        name: item.name + item.projectId,
        meta: {
          title: item.title,
          projectId: item.projectId
        },
        params: {
          projectId: item.projectId
        },
        component: () => import(`@\/views\/management\/${item.name}.vue`)
      })
      //元数据按钮
    } else if (!/bookmark/.test(item.name)) {
      otherRouter.children.push({
        path: `/view/${item.name}/:projectId`,
        name: item.name + item.projectId,
        meta: {
          title: item.title,
          projectId: item.projectId
        },
        params: {
          projectId: item.projectId
        },
        component: () => import(`@\/views\/${item.name}\/${item.name}.vue`)
      })
    }
  })
};


util.getLastUrl = (str, yourStr) => str.slice(str.lastIndexOf(yourStr)); //取到浏览器出现网址的最后"/"出现的后边的字符

util.transDataType = (h, { column, index, row }) => {
  switch (row.dataType) {
    case 'string':
      return h('div', {}, '文本');
    case 'number':
      return h('div', {}, '数值');
    case 'list':
      return h('div', {}, '列表');
    case 'date':
      return h('div', {}, '时间');
    case 'boolean':
      return h('div', {}, '布尔');
  }
};

util.formatXAxis = (data, vm) => {
  switch (vm.timeUnit) {
    case 'minute':
      return data.map(item => item.substring(0, 16));
    case 'hour':
      return data.map(item => item.substring(0, 13) + '时');
    case 'day':
      return data.map(item => item.substring(0, 10));
    case 'week':
      return data.map(item => `${item.substring(0, 10)}当周`);
    case 'month':
      return data.map(item => `${item.substring(0, 7)}月`);
    case 'year':
      return data.map(item => `${item.substring(0, 4)}年`);
  }
};

//统计图随机颜色
util.randomColor = () => {
  let r = Math.floor(Math.random() * 256);
  let g = Math.floor(Math.random() * 256);
  let b = Math.floor(Math.random() * 256);
  let color = '#' + r.toString(16) + g.toString(16) + b.toString(16);
  return color;
};

// timeRange转为对应的时间结果
util.setDateRes = (range) => {
  let res = { viewDate: [], compared: {}, isDynamic: false, term: '' };
  if (range.length === 1) {
    if (range[0].dynamic) {
      let dynamicUnit = range[0].dynamic.unit;
      let dynamicRange = range[0].dynamic.range;
      if (!dynamicRange) {
        res.viewDate = [presetTime[dynamicUnit].from, presetTime[dynamicUnit].to];
      } else {
        let _res = presetTime[dynamicUnit](dynamicRange);
        res.viewDate = [_res.from, _res.to];
      }
      res.isDynamic = true;
    } else {
      res.viewDate = [range[0].from, range[0].to];
    }
  } else {
    if (range[0].dynamic) {
      let dynamicUnit = range[0].dynamic.unit;
      let dynamicRange = range[0].dynamic.range;
      if (!dynamicRange) {
        res.viewDate = [presetTime[dynamicUnit].from, presetTime[dynamicUnit].to];
        res.compared = setComparedRes(res.viewDate, range);
      } else {
        let _res = presetTime[dynamicUnit](dynamicRange);
        res.viewDate = [_res.from, _res.to];
        res.compared = setComparedRes(res.viewDate, range);
      }
      res.isDynamic = true;
      res.term = range[1].dynamic.term;
    } else {
      res.viewDate = [range[0].from, range[0].to];
      res.compared = range[1];
    }
  }
  return res;
};

const setComparedRes = (viewDate, range) => {
  const [start, end] = viewDate;
  const startTime = new Date(start).getTime();
  const endTime = new Date(end).getTime();
  const rangeDay = Math.floor((endTime - startTime) / 86400000);
  const startDate = new Date(start);
  let from = null, to = null, fromTime = null;

  let comparedRange = range[1].dynamic.range;
  let { unit, term } = range[1].dynamic;
  /*if (comparedRange) {
    from = new Date(new Date().getTime() - comparedRange[0] * 86400000);
    to = new Date(new Date().getTime() - (comparedRange[1] || 1) * 86400000);
  } else {*/
  if (term) {
    if (term === 'previous') {
      // 上一时段
      if (/yesterday|today/.test(unit)) {
        from = new Date(startTime - 86400000);
      } else if (/lastWeek|currentWeek/.test(unit)) {
        from = new Date(startTime - 7 * 86400000);
      } else if (/lastMonth|currentMonth/.test(unit)) {
        from = new Date(startDate.getFullYear(), startDate.getMonth() - 1, 1);
      } else if (/lastYear|currentYear/.test(unit)) {
        from = new Date(startDate.getFullYear() - 1, 0, 1);
      } else {
        from = new Date(startTime - (rangeDay + 1) * 86400000);
      }
    } else if (term === 'sameTermOfLastYear') {
      // 去年同期
      from = new Date(startDate.getFullYear() - 1, startDate.getMonth(), startDate.getDate());
    }
    fromTime = new Date(from).getTime();
    to = new Date(fromTime + rangeDay * 86400000);
  } else {
    from = new Date(new Date().getTime() - comparedRange[0] * 86400000);
    to = new Date(new Date().getTime() - (comparedRange[1] || 1) * 86400000);
  }
  // }
  return { from: from.Format('start'), to: to.Format() };
};

export const findNodeUpperByClasses = (ele, classes) => {
  let parentNode = ele.parentNode
  if (parentNode) {
    let classList = parentNode.classList
    if (classList && classes.every(className => classList.contains(className))) {
      return parentNode
    } else {
      return findNodeUpperByClasses(parentNode, classes)
    }
  }
}

util.dateFormat = function (date, format) {
  // 如果是时间戳的话那么转换成Date类型
  if (typeof date === 'number') {
    date = new Date(date)
  } else if (typeof date === 'string') {
    date = new Date(parseInt(date))
  }

  let o = {
    // 月份
    'M+': date.getMonth() + 1,
    // 日
    'd+': date.getDate(),
    // 小时
    'h+': date.getHours(),
    // 分
    'm+': date.getMinutes(),
    // 秒
    's+': date.getSeconds(),
    // 季度
    'q+': Math.floor((date.getMonth() + 3) / 3),
    // 毫秒
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return format
}

export default util;



// WEBPACK FOOTER //
// ./src/libs/util.js